module.exports = __webpack_public_path__ + "static/img/ruanjian.21ec71a6.png";